<template>
  <section class="content">
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-2">
                <label>Date</label>
                <date-picker  ref="tran" v-model="transactionDate"  valueType="format" v-if="!englishDateEnabled"/>
                <InputMask  mask="9999-99-99" type="text" v-else class="nepali-calendar" id="transactionDate" v-model="transactionDate"/>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="voucher">Voucher</label>
              <InputText v-model="voucherNo" id="voucher" disabled/>
            </div>
              <!-- <div class="col-md-2" v-if="account.bankAccount">
                 <label for="Pdc" class=" control-label">Pdc</label>
                 <Checkbox id="pdc" v-model="pdc" :binary="true" />
              </div> -->
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
               <label >Account</label>
                <!-- <Dropdown
                  v-model="account"
                  :options="accountMasterList"
                  optionLabel="name"
                 class="dropDown"
                 :filter="true"
                  placeholder="Select Account"
                /> -->
                 <AutoComplete v-model="account" filterMatchMode='contains'
                 :suggestions="filteredAccounts" @complete="searchItem($event)"
                  field="name" ref="itm" @change="nepaliDate">
                 </AutoComplete>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label  for="drAmount">Debit Amount</label>
                <!-- <input  class="form-control" id="drAmount" v-model="txnAmountDr"
                v-if="txnAmountCr > 0" disabled /> -->
                <InputNumber onfocus="if (this.value === '0.00')
                                this.value = ''" id="drAmount" bodyStyle="text-align: right" v-model="txnAmountDr"  :minFractionDigits="2" :maxFracionDigits="4"
                 v-if="txnAmountCr > 0" disabled />
                <!-- <input  class="form-control" id="drAmount" v-model="txnAmountDr"
                v-else /> -->
                <InputNumber onfocus="if (this.value === '0.00')
                                this.value = ''" id="drAmount" bodyStyle="text-align: right" v-model="txnAmountDr"  :minFractionDigits="2" :maxFracionDigits="4"
                 v-else />
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label  for="crAmount">Credit Amount</label>
                <!-- <input type="text" class="form-control" id="crAmount" v-model="txnAmountCr"
                 v-if="txnAmountDr > 0 " disabled/> -->
                 <InputNumber onfocus="if (this.value === '0.00')
                                this.value = ''" id="crAmount" bodyStyle="text-align: right" v-model="txnAmountCr" :minFractionDigits="2" :maxFracionDigits="4"
                 v-if="txnAmountDr > 0 " disabled />
                <!-- <input type="text" class="form-control" id="crAmount" v-model="txnAmountCr"
                 v-else /> -->
                 <InputNumber onfocus="if (this.value === '0.00')
                                this.value = ''" id="crAmount" bodyStyle="text-align: right" v-model="txnAmountCr" :min="0" :minFractionDigits="2" :maxFracionDigits="4"
                  v-else />
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label  for="shortNarr">Short Narration</label>
                <InputText id="shortNarr" v-model="narration3"/>
              </div>

              <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="!account.isBankAccount" >
                <Button class="p-button p-component addNewBtn btn-btm-0"
                @click.prevent="addTransactionToDTO" :label="!editDTO?'Add':'Update'"/>
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="!account.isBankAccount" >
                <Button v-show="editDTO" class="p-button-raised p-button-danger"
                @click.prevent="resetAccountDto" label="Cancel"/>
              </div>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
                <label  for="closingBalance" v-if="account.closingBalance >= 0 || account.closingBalance < 0">Cur. Bal:</label>
                <b style="color:red;" v-if="account.closingBalance>0">{{(account.closingBalance).toFixed(2) + ' ' +'Cr'}}</b>

                <b v-else-if="account.closingBalance === 0">
                  {{(account.closingBalance).toFixed(2)}}
                </b>
                <b style="color:green;" v-else-if="account.closingBalance < 0">
                    {{(account.closingBalance).toFixed(2) * (-1)  + ' ' + 'Dr'}}
                </b>
              </div>
              <div class="p-field p-col-12 p-md-2"></div>
               <div class="p-field p-col-12 p-md-2" v-show="account.isBankAccount">
                  <label  for="">Cheque Date</label>
                  <date-picker  v-model="chequeDate" valueType="format" v-if="!englishDateEnabled" />
                  <InputMask mask="9999-99-99"  type="text" v-else  class="nepali-calendar" id="chequeDate" v-model="chequeDate"/>
              </div>
              <!-- {{chequeDate}} -->
               <div class="p-field p-col-12 p-md-2" v-show="account.isBankAccount">
                <label for="chequeNo" >Cheque No</label>
                 <InputText v-model="chequeNumber" id="chequeNo"/>
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="account.isBankAccount">
                <Button class="p-button p-component addNewBtn btn-btm-0"
                @click.prevent="addTransactionToDTO" :label="!editDTO?'Add':'Update'"/>
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="account.isBankAccount">
                <Button v-show="editDTO" class="p-button-raised p-button-danger"
                  @click.prevent="resetAccountDto" label="Cancel"/>
              </div>
            </div>
        </form>
        <div class="p-field p-col-12 p-md-12">
          <div >
            <div class="jouscroll">
              <table class="table table-bordered ">
                <thead>
                  <tr>
                    <th >SN</th>
                    <th >Account Name</th>
                    <th >Debit Amount</th>
                    <th >Credit Amount</th>
                    <th  v-if="this.bank">Cheque Date</th>
                    <th  v-if="this.cheque">Cheque Number</th>
                    <th >Short Narration</th>
                    <th >Action</th>
                  </tr>
                </thead>
                <tbody  v-for="(account,index) in transactionDetailDTOList " :key="index">
                  <tr>
                    <td>{{index+1}}</td>
                    <td>{{account.accountMaster.name}}</td>
                    <td style="text-align:right">{{account.drCr == 'D'?account.txnAmount:''}}</td>
                    <td style="text-align:right">{{account.drCr == 'C'?account.txnAmount:''}} </td>
                    <td v-if="bank">{{account.chequeDate}} </td>
                    <td v-if="cheque">{{account.chequeNumber}} </td>
                    <td >{{account.narration3}} </td>
                    <td>
                      <Button class="p-button-raised p-button-success"
                      @click="editAccountFromDTO(account, index)" icon="pi pi-pencil"/>
                      <Button class="p-button-raised p-button-danger"
                      @click="deleteAccountFromDTO(account,index)" icon="pi pi-trash"/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <hr>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-3">
              <label class="_drcr" style="margin-left:14em;">Total</label>
            </div>
            <div class="p-field p-col-12 p-md-3">
              <span style="margin-left:12em;color:#3c8dbc;font-size: 12px;">{{drtotal.toFixed(4)}}</span>
            </div>
          <div class="p-field p-col-12 p-md-3">
            <span style="margin-left:5em;color:#3c8dbc;font-size: 12px;">{{crTotal.toFixed(4)}}</span>
         </div>
         <div class="p-field p-col-12 p-md-3">
           <label class="_drcr">Diff Amt</label>
           <span style="margin-left:2em;color:green;font-size: 12px;" v-if="calculation===0">{{calculation.toFixed(4)}}</span>
           <span v-else style="margin-left:2em;color:red;font-size: 12px;">{{calculation.toFixed(4)}}</span>
         </div>
        </div>
         <hr>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-4">
            <label for="narration1">Narration</label>
            <Textarea id="narration1" rows="6" v-model="narration"/>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-6"></div>
          <div class="p-field p-col-12 p-md-1">
            <Button label="Cancel" class="p-button-raised p-button-danger" @click="goBack()"
            v-if="this.cashWithdraw!=undefined"/>
          </div>
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-warning" @click.prevent="reset"
             v-if="this.cashWithdraw==undefined" label="Reset" icon="pi pi-refresh"/>
           </div>
           <div class="p-field p-col-12 p-md-1">
            <Button icon="pi pi-save" class="p-button-raised p-button-success"
            @click.prevent="saveCashWithdraw" :label="!editing?'Save':'Update'"/>
          </div>
            <div class="p-field p-col-12 p-md-1">
             <Button class="p-button-raised p-button-secondary" label="Print" icon="pi pi-print"/>
           </div>
           <div class="p-field p-col-12 p-md-2">
             <Button class="p-button-raised p-button-secondary" label="Generate PDF" icon="pi pi-download"/>
          </div>
      </div>
    </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Textarea from 'primevue/textarea'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
export default {
  name: 'cashWithdrawEntry',
  props: ['cashWithdraw'],
  data() {
    return {
      name: '',
      pdc: false,
      englishDateEnabled: true,
      transactionDate: null,
      account: '',
      txnAmountDr: 0,
      txnAmountCr: 0,
      narration3: '',
      narration: '',
      drCr: '',
      drtotal: 0,
      crTotal: 0,
      difference: 0,
      chequeDate: null,
      chequeNumber: '',
      transactionDetailDTOList: [],
      transactionDeleteList: [],
      bank: false,
      editing: false,
      voucherNo: null,
      editDTO: false,
      index: null,
      tranId: null,
      tranModuleType: null,
      loading: false,
      cheque: false,
      filteredAccounts: null
    }
  },
  computed: {
    // voucherNo() {
    //   return this.$store.state.accounting.voucherNo
    // },
    accountMasterList() {
      return this.$store.state.accounting.accountList
    },
    calculation() {
      let difference = 0
      this.drtotal = 0
      this.crTotal = 0
      for (let i = 0; i < this.transactionDetailDTOList.length; i++) {
        if (this.transactionDetailDTOList[i].drCr === 'D') {
          this.drtotal += parseFloat(this.transactionDetailDTOList[i].txnAmount)
        } else {
          this.crTotal += parseFloat(this.transactionDetailDTOList[i].txnAmount)
        }
        difference = parseFloat(this.drtotal) - parseFloat(this.crTotal)
      }
      return difference
    }
  },
  mounted() {
    if (this.cashWithdraw === undefined) {
      this.maxVoucherNo()
    }
    this.accountList()
    if (this.cashWithdraw !== undefined) {
      this.editCashWithdraw()
    }
    this.checkEnglish()
    if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.state.isEnglishDateEnabled && this.cashWithdraw === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async maxVoucherNo() {
      let response = await this.$store.dispatch('maxVoucherNoCashWithdraw')
      if (this.cashWithdraw === undefined) {
        this.voucherNo = response.data.data
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.voucherNo
        this.narration
      }
    },
    async accountList() {
      await this.$store.dispatch('accountMasterList')
    },
    addTransactionToDTO() {
      if (this.account === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select account!', life: 10000})
        return
      } else if (this.txnAmountDr <= 0 && this.txnAmountCr <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter amount!', life: 10000})
        return
      }
      if (this.account.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please Select valid account!', life: 10000})
        return
      }
      if (this.account.isBankAccount && this.txnAmountCr <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'The amount must be in credit side!', life: 10000})
        return
      }
      if (this.txnAmountDr > 0) {
        this.drCr = 'D'
        this.txnAmount = this.txnAmountDr
      } else {
        this.txnAmount = this.txnAmountCr
        this.drCr = 'C'
      }
      this.checkForChequeDate()
      let transaction = {
        accountMaster: this.account,
        narration3: this.narration3,
        txnAmount: this.txnAmount,
        chequeDate: this.chequeDate,
        chequeNumber: this.chequeNumber,
        drCr: this.drCr
      }
      if (!this.editDTO) {
        this.transactionDetailDTOList.push({...transaction})
      } else {
        this.transactionDetailDTOList.splice(this.index, 1, {...transaction})
      }
      this.resetAccountDto()
      this.focusInput()
    },
    editAccountFromDTO(data, index) {
      this.resetAccountDto()
      // this.checkForChequeDate()
      this.editDTO = true
      this.account = data.accountMaster
      this.drCr = data.drCr
      if (this.drCr === 'D') {
        this.txnAmountDr = data.txnAmount
      } else {
        this.txnAmountCr = data.txnAmount
      }
      this.chequeNumber = data.chequeNumber
      this.chequeDate = data.chequeDate
      // this.accountMasterId = data.accountMaster.id
      this.narration3 = data.narration3
      this.index = index
    },
    async saveCashWithdraw() {
      let response = ''
      let cashWithdraw = {
        transactionDate: this.transactionDate,
        narration1: this.narration,
        chequeNumber: this.chequeNumber,
        chequeDate: this.chequeDate,
        chequeDateNp: this.chequeDate,
        tranId: this.tranId,
        tranModuleType: this.tranModuleType,
        transactionDetailDTOList: this.transactionDetailDTOList,
        transactionDeleteList: this.transactionDeleteList,
        transactionNepaliDate: this.transactionDate
      }
      if (this.transactionDetailDTOList.length < 1) {
        this.$toast.add({severity: 'error', summary: '', detail: 'The transaction must have at least two transaction heads!', life: 10000})
        return
      }
      if (this.calculation !== 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Debit and credit amount should be equal!', life: 10000})
        return
      }
      if (!this.editing) {
        this.loading = true
        response = await this.$store.dispatch('saveCashWithdraw', cashWithdraw)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updateCashWithdraw', cashWithdraw)
        this.loading = false
        this.editing = false
        this.$router.back()
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        await this.maxVoucherNo()
        this.reset()
        this.focusAfterSave()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    async editCashWithdraw() {
      let response = await this.$store.dispatch('loadaccountLedger', this.cashWithdraw)
      if (response.data.status === 'SUCCESS') {
        this.editing = !this.editing
        let resp = response.data.data
        this.voucherNo = resp.voucher
        if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
          this.transactionDate = resp.transactionNepaliDate
        } else {
          this.transactionDate = resp.transactionDate
        }
        this.transactionDetailDTOList = resp.transactionDetailDTOList
        this.narration = resp.narration1
        this.tranId = resp.tranId
        this.tranModuleType = this.cashWithdraw.tranModuleType
      }
    },
    resetAccountDto() {
      this.account = ''
      this.txnAmountDr = 0
      this.txnAmountCr = 0
      this.narration3 = ''
      this.editDTO = false
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        this.chequeDate = this.$store.state.nepaliNewDate
      } else {
        this.chequeDate = new Date().toISOString().slice(0, 10)
      }
      this.chequeNumber = ''
    },
    deleteAccountFromDTO(data, id) {
      this.checkForChequeDate()
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        this.chequeDate = this.$store.getters.nepaliNewDate
      } else {
        this.chequeDate = new Date().toISOString().slice(0, 10)
      }
      if (this.editing && data.id !== null) {
        this.transactionDeleteList.push({...data})
      }
      this.transactionDetailDTOList.splice(id, 1)
    },
    reset() {
      this.resetAccountDto()
      this.transactionDetailDTOList = []
      this.editing = false
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.transactionDate = new Date().toISOString().slice(0, 10)
        this.chequeDate = this.$store.getters.nepaliNewDate
      }
    },
    setNepaliDate() {
      if (this.cashWithdraw === undefined) {
        this.transactionDate = this.$store.getters.nepaliNewDate
        this.chequeDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.transactionDate = new Date().toISOString().slice(0, 10)
      this.chequeDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        $('#transactionDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.transactionDate = $('#transactionDate').val()
          }
        })
        if (this.account.isBankAccount) {
          $('#chequeDate').nepaliDatePicker({
            ndpYear: true,
            ndpMonth: true,
            ndpYearCount: 10,
            disableBefore: this.$store.state.startDate,
            disableAfter: this.$store.state.endDate,
            onChange: () => {
              this.chequeDate = $('#chequeDate').val()
            }
          })
        } else {
          this.chequeDate = ''
        }
      }
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredAccounts = [...this.accountMasterList]
        } else {
          this.filteredAccounts = this.accountMasterList.filter((account) => {
            return account.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    focusAfterSave() {
      this.$refs.tran.focus()
    },
    goBack() {
      if (this.transactionDeleteList.length > 0) {
        this.cashWithdraw.transactionDetailDTOList = this.transactionDeleteList
      }
      this.$router.back()
    },
    checkForChequeDate() {
      if (this.account.isBankAccount || this.account.isBankAccount === undefined) {
        if (this.account.isBankAccount) {
          this.bank = true
        } else if (this.account.isBankAccount === undefined) {
          this.bank = false
        } else if (!this.account.isBankAccount) {
          this.bank = false
        }
        if (this.chequeNumber !== '') {
          this.cheque = true
        } else if (this.chequeNumber === '') {
          this.cheque = false
        }
      }
    }
  },
  components: {
    Dropdown,
    DatePicker,
    Checkbox,
    AutoComplete,
    InputNumber,
    InputMask,
    Textarea,
    Button,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
._drcr{
  color:red;
}

</style>



// WEBPACK FOOTER //
// cashwithdraw.vue?6c98686e